/**
 * @author vishwadeep.kapoor
 * Profile constants
 */

import { constants } from '../../devUtils';
import endPoints from '../../config/endPoints';
import { MAKE_FILTER_TRACKING_LABEL } from '../RestaurantsList/constants';

export const DEFAULT_ACTION = '/Profile/DEFAULT_ACTION';
export const PASSWORD_UPDATE_SUCCESS = '/Profile/PASSWORD_UPDATE_SUCCESS';

const PROFILE_CONSTANT = Object.freeze({
  WALLET_REGISTER: '/Profile/WALLET_REGISTER',
  AADHAR_REGISTER: '/Profile/AADHAR_REGISTER',
  CARD_ACTIVATE: '/Profile/CARD_ACTIVATE',
});

/**
 * @description do not change the key values
 */
const PROFILE_LEFT_NAV = [
  { key: 1, value: 'My Profile', icon: endPoints.PROFILE_ICON.URL, link: constants.LINK_MY_PROFILE },
  { key: 7, value: 'Activate Physical Card', icon: endPoints.CARD_MONEY_BILL.URL, link: constants.LINK_ACCOUNT_ACTIVATE },
  // { key: 2, value: 'My Bookings', link: constants.LINK_MY_BOOKINGS, eventKey: 'Bookings tab' },
  { key: 4, value: 'My Orders', icon: endPoints.PROFILE_ORDER.URL, link: constants.LINK_MY_ORDERS, eventKey: 'Orders tab' },
  { key: 3, value: 'My e-Gift Cards', icon: endPoints.PROFILE_GIFT_CARD.URL, link: constants.LINK_MY_EVOUCHERS, eventKey: 'e-Gift Cards tab' },
  { key: 5, value: 'Zaggle Pay Balance', icon: endPoints.CARD_MONEY_BILL.URL, link: constants.LINK_PAY_BALANCE, eventKey: 'Pay Balance Tab' },
];

export const GET_KEYS_OBJ_INARRAY = (obj) => {
  const array = [];
  for (const prop in obj) {
    array.push(prop);
  }
  return MAKE_FILTER_TRACKING_LABEL(array);
};

export { PROFILE_CONSTANT, PROFILE_LEFT_NAV };



// WEBPACK FOOTER //
// client/containers/Profile/constants.js